import Button from 'mango-ui/control/Button';
import Slider from 'mango-ui/control/Slider';
import Switch from 'mango-ui/control/Switch';
import * as React from 'react';

export default ({
  processing, total, count, rest,
  onDisjointPoints, buffer, onAdjust,
  onToggleParkPointLayerVisibility,
  isParkPointVisible, days, onChangeDays,
}: {
  processing: boolean;
  total: number;
  count: number;
  rest: number;
  onDisjointPoints: () => void;
  buffer: number;
  onAdjust: (value: number) => void;
  onToggleParkPointLayerVisibility: IFunction;
  isParkPointVisible: boolean;
  days: number;
  onChangeDays: IFunction;
}) => {
  return (
    <div>
      <Switch
        label="隐藏/显示停车点"
        active={isParkPointVisible}
        onToggle={onToggleParkPointLayerVisibility}
      />
      <div style={{ padding: 6, paddingTop: 0 }}>
        <span>获取数据的天数</span>
        <Slider
          flexRate={1}
          min={1}
          max={10}
          step={1}
          defaultValue={days}
          onChange={onChangeDays}
          labelCount={4}
          renderLabel={value => value}
        />
        <span>停车区缓冲区 {buffer}m</span>
        <Slider
          flexRate={1}
          min={0}
          max={50}
          step={1}
          defaultValue={buffer}
          onChange={onAdjust}
          labelCount={6}
          renderLabel={value => value}
        />
        <br/>
        <Button primary brick onClick={onDisjointPoints}>过滤缓冲区内点</Button>
        <br/>
        处理进度：{processing ? `${count}/${total}` : '处理完毕'}
        <br/>
        剩余点对：{`${rest}/${total}`}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/ParkPointPanelView.tsx